function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("title", null, "React Logo");

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("circle", {
  cx: 0,
  cy: 0,
  r: 2.05,
  fill: "#61dafb"
});

var _ref4 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("g", {
  stroke: "#61dafb",
  strokeWidth: 1,
  fill: "none"
}, /*#__PURE__*/React.createElement("ellipse", {
  rx: 11,
  ry: 4.2
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 11,
  ry: 4.2,
  transform: "rotate(60)"
}), /*#__PURE__*/React.createElement("ellipse", {
  rx: 11,
  ry: 4.2,
  transform: "rotate(120)"
}));

var SvgReactNative = function SvgReactNative(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-11.5 -10.23174 23 20.46348",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReactNative, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "react-native.svg";
export { ForwardRef as ReactComponent };